import React from 'react';

function PrimaryCard({ className, children, ...rest}) {
  return <div className={`p-5 border border-gray-200 rounded-xl shadow-lg ${className}`} {...rest}>
    {children}
  </div>;
};

export default PrimaryCard;
